import Ammo from "ammojs-typed";
class KinematicBody {
    margin;
    transform;
    shape;
    body;
    /**
     * Kinematic body.
     * @param config the body's physics properties configuration.
     * @param position the body's position.
     * @param rotation the body's rotation.
     * @param shapeController class responsible for creating a physics shape.
     * @param meshController the entity's mesh.
     */
    constructor(config, position, rotation, shapeController, meshController) {
        this.margin = 0.05;
        this.transform = this.createTransform(position, rotation);
        this.shape = shapeController.createShape(meshController.getGeometry, this.margin);
        this.body = this.createBody(config);
    }
    /**
     * Convert a ThreeJS Vector3 into an AmmoJS Vector3.
     * @param position the ThreeJS position Vector3.
     * @returns the converted vector.
     */
    convertPosition(position) {
        return new Ammo.btVector3(position.x, position.y, position.z);
    }
    /**
     * Convert a ThreeJS Quaternion into an AmmoJS Quaternion.
     * @param rotation the ThreeJS rotation Quaternion.
     * @returns the converted quaternion.
     */
    convertRotation(rotation) {
        return new Ammo.btQuaternion(rotation.x, rotation.y, rotation.z, rotation.w);
    }
    /**
     * Create and configure a transform for the rigid body.
     * @param position the initial position.
     * @param rotation the initial rotation.
     * @returns the created transform object.
     * @private
     */
    createTransform(position, rotation) {
        const transform = new Ammo.btTransform();
        transform.setIdentity();
        transform.setOrigin(this.convertPosition(position));
        transform.setRotation(this.convertRotation(rotation));
        return transform;
    }
    /**
     * create a ghost object body.
     * @returns the created ghost object.
     * @private
     */
    createBody(config) {
        const body = new Ammo.btPairCachingGhostObject();
        body.setWorldTransform(this.transform);
        body.setCollisionShape(this.shape);
        body.setCollisionFlags(config.COLLISION_FLAGS);
        body.setActivationState(config.ACTIVATION_STATE);
        body.activate(true);
        return body;
    }
    get getTransform() {
        return this.transform;
    }
    get getShape() {
        return this.shape;
    }
    get getBody() {
        return this.body;
    }
    get getMargin() {
        return this.margin;
    }
}
export default KinematicBody;
